let shippingInfo = document.querySelector('.js-shipping-info');

if (shippingInfo) {
    function convertDateToEST(date) {
        let estOffset = -5 * 60;
        let utcTime = date.getTime() + (date.getTimezoneOffset() * 60000);

        return new Date(utcTime + (estOffset * 60000));
    }

    function getNextBusinessDay(date) {
        do {
            date.setDate(date.getDate() + 1);
        } while (date.getDay() === 0 || date.getDay() === 6);

        return date;
    }

    function getCutoffDate() {
        let currentDate = new Date();
        let estTime = convertDateToEST(currentDate);

        let cutoffDate = new Date(estTime);
        cutoffDate.setHours(14, 0, 0, 0); // Set cutoff time to 2 PM EST

        if (estTime.getHours() >= 14 || estTime.getDay() === 6 || estTime.getDay() === 0) {
            cutoffDate = getNextBusinessDay(cutoffDate);
        }

        return cutoffDate;
    }

    function calculateDeliveryDate() {
        let cutoffDate = getCutoffDate();
        let deliveryDate = getNextBusinessDay(new Date(cutoffDate));

        let deliveryMonth = (deliveryDate.getMonth() + 1).toString().padStart(2, '0');
        let deliveryDay = deliveryDate.getDate().toString().padStart(2, '0');

        return `${deliveryMonth}/${deliveryDay}`;
    }

    function updateCountdownTimer() {
        let currentDate = new Date();
        let estTime = convertDateToEST(currentDate);
        let cutoffDate = getCutoffDate();

        let timeDiff = cutoffDate.getTime() - estTime.getTime();
        let secondsRemaining = Math.floor(timeDiff / 1000);

        let hours = Math.floor(secondsRemaining / 3600);
        secondsRemaining -= hours * 3600;
        let minutes = Math.floor(secondsRemaining / 60);
        let seconds = secondsRemaining % 60;

        document.querySelector('.js-countdown').textContent = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }

    function updateDeliveryInfo() {
        let deliveryDate = calculateDeliveryDate();
        document.querySelector('.js-delivery').textContent = deliveryDate;

        updateCountdownTimer();
        setInterval(updateCountdownTimer, 1000);
    }

    function hideShippingInfoForSpecificTimezones() {
        // let currentDate = new Date();
        // let timezoneOffsetMinutes = currentDate.getTimezoneOffset();
        // let timezoneOffsetHours = timezoneOffsetMinutes / 60;
        //
        // if (timezoneOffsetHours == 7 || timezoneOffsetHours == 6 || timezoneOffsetHours == 5) {
        //     shippingInfo.classList.add('shipping-info--visible');
        // }

        shippingInfo.classList.add('shipping-info--visible');
    }

    hideShippingInfoForSpecificTimezones();
    updateDeliveryInfo();
}
